import React, {useContext, useState} from 'react';
import {PortalSelect, PortalSelectOption} from '../PortalSelect';
import {BASIC_ELEMENT_SCHEMA} from '../layout/Group';
import {ModelContext} from '../metadata/ModelSource';
import { ApplicationActionsContext } from '../data/ApplicationDataSource';
import Select, {Props} from 'react-select';
import { FormContext } from '../metadata/MDForm';
import { formatMoneyAmountNoDecimal } from '../../utils/formatUtils';
import {Attribute, AttributeCondition} from "../metadata/api/attribute";
import { getOptionsForAttr } from './coderefs';

const mapAndFormat = (array) => {
  return array.map(
    (value) => `$${formatMoneyAmountNoDecimal(parseInt(value))}`
  );
};

const formatPrevious = (previousValue) => {
  const prevArray = previousValue.split('/');
  const formatted = mapAndFormat(prevArray);
  return `${formatMoneyAmountNoDecimal(formatted)}`;
};

export function CollisionDeductibleSelector({attr, additionalOptions, dataType, ...props}) {

  const formContext = useContext(FormContext);
  let attribute = formContext.metadata[attr];
  const { setValueByAttr, getValueByAttr } = formContext;

  let options = getOptionsForAttr(attribute).list;

  let allOptions = options;
  if (additionalOptions && additionalOptions.length) {
    allOptions = [...options, ...additionalOptions];
  }

  let mustBeNoCoverage = false;
  if(getValueByAttr('Vehicle.CollCoverage') === '0') {
    allOptions = [{value:"0", name:"No Coverage"}];
    mustBeNoCoverage = true;
    if(getValueByAttr('Vehicle.CollisionDed') !== '0')
      setValueByAttr('Vehicle.CollisionDed', '0');
  }


  let selected = null;
  let children = allOptions.map(({value, name}) => <PortalSelectOption value={value}>
      {name}
    </PortalSelectOption>);
      options = React.Children.map(children, el => {
      if (!el.props) {
        return null;
      }
      const obj = {
        label: el.props.children,
        value: el.props.value
      };
      if (el.props.value === props.value || mustBeNoCoverage) {
        selected = obj;
      }
      return obj;
  });

  const actions = useContext(ApplicationActionsContext);
  const previousValue = selected;
  const [selectedValue, setSelectedValue] = useState(previousValue);

  const handleChange = (selected) => {
    setValueByAttr(attr, selected.value);
    setSelectedValue(selected);
    actions.saveApplication();
  };

  let stylesUpdater = customStylesUpdater2;
  if(dataType && dataType === 'SelectUpdate'){
    stylesUpdater = customStylesUpdater;
  }

  return <Select
      {...props}
      aria-label="Select"
      styles={stylesUpdater}
      title="Select"
      openMenuOnFocus
      placeholder={null}
      options={options}
      value={selected}
      onChange={handleChange}
      components={{
        IndicatorSeparator: () => null,
      }}
      theme={(theme) => ({
        ...theme,
        borderRadius: 4,
        zIndex: 3,
        colors: {
          ...theme.colors,
          primary25: 'rgb(0, 115, 157, 0.1)',
          primary: 'rgba(0, 115, 157, 0.5)',
          neutral30: 'rgba(0, 115, 157, 0.5)',
        },
      })}
    />;

}

const customStylesUpdater = {
  control: (base) => ({
    ...base,
    width: '158px',
    '&:hover': {
      cursor: 'pointer',
    },
  }),
  menu: (styles) => ({ ...styles, zIndex: 999 }),
};

const customStylesUpdater2 = {
  control: (base) => ({
    ...base,
    '&:hover': {
      cursor: 'pointer',
    },
  }),
  menu: (styles) => ({ ...styles, zIndex: 999 }),
};

CollisionDeductibleSelector.schema = BASIC_ELEMENT_SCHEMA;